import { motion } from 'framer-motion';
import { CustomToastProps } from './types';
import React, { useEffect } from 'react';
import Toast from 'react-bootstrap/Toast';

export const CustomToast: React.FC<CustomToastProps> = ({ show, title, message, imgSrc, timeAgo, type, onClose, duration }) => {
  const variants = {
    hidden: { opacity: 0, x: 200 },
    visible: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: 200 },
  };

  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [show, onClose, duration]);

  const headerClass = type === 'success' ? 'toast-success' : 'toast-error';

  return (
    <motion.div className="justify-content-center" initial="hidden" animate={show ? 'visible' : 'hidden'} variants={variants} exit="exit">
      <Toast show={show} onClose={onClose}>
        <Toast.Header className={headerClass}>
          {imgSrc && <img src={imgSrc} className="rounded me-2" alt="Toast Image" />}
          <strong className="me-auto">{title}</strong>
          {timeAgo && <small>{timeAgo}</small>}
        </Toast.Header>
        <Toast.Body className="toast-background">{message}</Toast.Body>
      </Toast>
    </motion.div>
  );
};
